import { render } from "./SideDishBody.vue?vue&type=template&id=14e6f988&scoped=true"
import script from "./SideDishBody.vue?vue&type=script&lang=js"
export * from "./SideDishBody.vue?vue&type=script&lang=js"

import "./SideDishBody.vue?vue&type=style&index=0&id=14e6f988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e6f988"]])

export default __exports__